'use strict';
/**
 * <death-screen> - brief dimming overlay + stats panel shown on death (see
 * client.js's deathScreen.classList.add/remove('screen-off')). See
 * settings-panel.js for the light-DOM / classic-script / load-order
 * rationale shared by all four panel components.
 */
class DeathScreen extends HTMLElement {
  connectedCallback() {
    if (this.childElementCount) return;
    this.innerHTML = `
      <div class="death-panel">
        <div class="death-stats">
          <span class="death-stat">
            <svg class="icon" aria-hidden="true"><use href="#icon-zap"/></svg>
            <span class="sr-only">Shots</span>
            <span class="death-stat-value" id="death-shots">0</span>
          </span>
          <span class="death-stat">
            <svg class="icon" aria-hidden="true"><use href="#icon-crosshair"/></svg>
            <span class="sr-only">Kills</span>
            <span class="death-stat-value" id="death-kills">0</span>
          </span>
        </div>
        <div id="death-reason"></div>
      </div>
    `;
  }
}

customElements.define('death-screen', DeathScreen);
